import { render, staticRenderFns } from "./VisualizzaPrenotazioni.vue?vue&type=template&id=c256a502"
import script from "./VisualizzaPrenotazioni.vue?vue&type=script&lang=js"
export * from "./VisualizzaPrenotazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports